// extracted by mini-css-extract-plugin
var _1 = "Checkbox_bordered__6d1f6";
var _2 = "Checkbox_horizontal__3fc81";
var _3 = "Checkbox_root__aa876";
var _4 = "Checkbox_vertical__218c0";
export { _1 as "bordered", _2 as "horizontal", _3 as "root", _4 as "vertical" }
